/* eslint-disable max-len */
export const galleryAreaMockedData = {
  medias:[
    {
      "id": 23115332,
      "externalId": null,
      "image": null,
      "imageThumb": null,
      "imageName": "https://img-new.cgtrader.com/items/4133465/cd2fa9b34e/trash-kit-3d-assetkit-3d-model-cd2fa9b34e.webp",
      "imageNameThumb": "https://img-new.cgtrader.com/items/4133465/cd2fa9b34e/thumb/trash-kit-3d-assetkit-3d-model-cd2fa9b34e.webp",
      "model": {
        "id": 23115332,
        "itemId": 4133465,
        "imageName": {
          "url": "https://img-new.cgtrader.com/items/4133465/cd2fa9b34e/trash-kit-3d-assetkit-3d-model-cd2fa9b34e.webp",
          "thumb": {
            "url": "https://img-new.cgtrader.com/items/4133465/cd2fa9b34e/thumb/trash-kit-3d-assetkit-3d-model-cd2fa9b34e.webp",
          },
          "large": {
            "url": "https://img-new.cgtrader.com/items/4133465/cd2fa9b34e/large/trash-kit-3d-assetkit-3d-model-cd2fa9b34e.webp",
          },
          "grid": {
            "url": "https://img-new.cgtrader.com/items/4133465/cd2fa9b34e/grid/trash-kit-3d-assetkit-3d-model-cd2fa9b34e.webp",
          },
          "gridLarge": {
            "url": "https://img-new.cgtrader.com/items/4133465/cd2fa9b34e/grid_large/trash-kit-3d-assetkit-3d-model-cd2fa9b34e.webp",
          },
        },
        "position": 1,
        "digest": "cd2fa9b34e",
        "adultContent": false,
        "createdAt": "2022-11-27T00:29:15.000Z",
        "copiedFromId": null,
        "adultByClarifai": null,
        "fileName": null,
        "collectionCollage": false,
        "remoteImageMissing": false,
        "adminRating": null,
        "domain": null,
        "autoGenerated": false,
        "skipItemTouch": false,
      },
      "type": null,
      "fileUrl": null,
      "adult": false,
      "visualType": "ItemImage",
      "autoGenerated": true,
      "width": 1920,
      "height": 1080,
    },
    {
      "id": 246552,
      "externalId": "aaNYol9mA-w",
      "image": "https://img-new.cgtrader.com/items/4133465/embeds/246552/hqdefault.jpg",
      "imageThumb": "https://img-new.cgtrader.com/items/4133465/embeds/246552/thumb_hqdefault.jpg",
      "imageName": null,
      "imageNameThumb": null,
      "model": {
        "id": 246552,
        "itemId": 4133465,
        "itemFileId": null,
        "type": "youtube",
        "externalId": "aaNYol9mA-w",
        "position": 1,
        "image": {
          "url": "https://img-new.cgtrader.com/items/4133465/embeds/246552/hqdefault.jpg",
          "thumb": {
            "url": "https://img-new.cgtrader.com/items/4133465/embeds/246552/thumb_hqdefault.jpg",
          },
          "large": {
            "url": "https://img-new.cgtrader.com/items/4133465/embeds/246552/large_hqdefault.jpg",
          },
          "grid": {
            "url": "https://img-new.cgtrader.com/items/4133465/embeds/246552/grid_hqdefault.jpg",
          },
        },
        "createdAt": "2022-11-26T18:12:00.000Z",
        "updatedAt": "2022-11-26T18:12:00.000Z",
        "copiedFromId": null,
      },
      "type": "youtube",
      "fileUrl": null,
      "adult": null,
      "visualType": "ItemEmbed",
      "autoGenerated": false,
    },
    {
      "id": 492555,
      "externalId": "19937891",
      "image": "https://img-new.cgtrader.com/items/6485895/embeds/492555/.jpg.jpg",
      "imageThumb": "https://img-new.cgtrader.com/items/6485895/embeds/492555/thumb_.jpg",
      "imageName": null,
      "imageNameThumb": null,
      "model": {
        "id": 492555,
        "itemId": 6485895,
        "itemFileId": 19937891,
        "type": "marmoset",
        "externalId": "19937891",
        "position": 1,
        "image": {
          "url": "https://img-new.cgtrader.com/items/6485895/embeds/492555/.jpg.jpg",
          "thumb": {
            "url": "https://img-new.cgtrader.com/items/6485895/embeds/492555/thumb_.jpg",
          },
          "large": {
            "url": "https://img-new.cgtrader.com/items/6485895/embeds/492555/large_.jpg",
          },
          "grid": {
            "url": "https://img-new.cgtrader.com/items/6485895/embeds/492555/grid_.jpg",
          },
        },
        "createdAt": "2025-10-02T09:47:31.000Z",
        "updatedAt": "2025-10-02T09:47:31.000Z",
        "copiedFromId": null,
      },
      "type": "marmoset",
      "fileUrl": "https://cgtfiles.s3.amazonaws.com/uploads/files/6485895/Chain_Barrier_A.mview",
      "adult": null,
      "visualType": "ItemEmbed",
      "autoGenerated": false,
    },
    {
      "id": 492556,
      "externalId": "19937892",
      "image": null,
      "imageThumb": null,
      "imageName": null,
      "imageNameThumb": null,
      "model": {},
      "type": null,
      "fileUrl": "https://cgtfiles.s3.amazonaws.com/uploads/files/6485895/Chain_Barrier_A.mp4",
      "adult": null,
      "visualType": "OpenStruct",
      "autoGenerated": false,
    },
  ],
  title: 'Trash Kit - 3D AssetKit',
  displayParentalLockOverlay: false,
  showAutoGeneratedImages: true,
}
